import React from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import Widgets from './Widgets';
import DashboardStudents from './dashboard';

const Dashboard = () => {

  return (
    <React.Fragment>
      <BreadCrumb title='Dashboard' pageTitle='' />
      <div className="grid grid-cols-12 gap-x-5">
        {/* Statistics (Widgets) - comes first on mobile */}
        <Widgets />
        {/* Recent Students - comes after widgets on mobile, before on larger screens */}
        <DashboardStudents />
      </div>
    </React.Fragment>
  );
};

export default Dashboard;